module.exports = __webpack_public_path__ + "static/media/c-ball.09f62dfd.gif";